<template>
  <div>
    <div class="column loading_block" v-if="!chart">
      <p>
        <span id="animateLoading"></span>
        {{ $t("msg.loading") }}...
      </p>
    </div>
    <canvas class="miniChart" v-else :id="'mainChartBlu' + chartId"></canvas>
  </div>
</template>
<script>
import Chart from "chart.js";
import moment from "moment";

export default {
  props: ["chartData", "bluValue"],
  created() {},
  mounted() {},
  data: () => ({
    chartId: (Math.random() * 100).toFixed(),
    chart: false,
    chartDataOnChart: {
      labels: [],
      prices: [],
    },

    stepSize: 10,
    min: 50,
    circle: 2,
  }),
  components: {},
  methods: {
    setChartData() {
      var ghostChart = document.querySelector(".chartjs-size-monitor");
      if (ghostChart) {
        ghostChart.remove();
      }

      this.chartId = (Math.random() * 100).toFixed();

      setTimeout(() => {
        this.$emit("chartLoaded");
        this.setUpChart("2", this.chartData);
      }, 1000);
    },

    setUpChart(dataSet, chartContent) {
      const maxTicksLimitGraph =
        chartContent.type == "week"
          ? 7
          : chartContent.type == "year" || chartContent.type == "ytd"
          ? 12
          : chartContent.type == "all" && 5;

      let arr;

      let labels = this.chartDataOnChart.labels.map((el) => el.slice(0, 16));

      let chartData = {
        type: "line",
        data: {
          labels,
          datasets: [
            {
              label: "BLUE (USDT)",
              data: this.chartDataOnChart.prices,
              backgroundColor: ["#424b7d"],
              borderColor: ["#424b7d"],
              fill: false,
              borderWidth: 2,
              lineTension: 0,
            },
          ],
        },
        options: {
          tooltips: {
            enabled: true,
            colors: "red",
            caretSize: 10,
            fill: true,
            displayColors: false,
            mode: "nearest",
          },

          legend: {
            display: false,
          },

          elements: {
            point: {
              pointStyle: "circle",
              radius: this.circle,
            },
          },

          scales: {
            xAxes: [
              {
                display: true,

                ticks: {
                  display: true,
                  autoSkip: false,
                  maxTicksLimit: maxTicksLimitGraph,
                  maxRotation: 30,

                  callback: function (value, index) {
                    if (value) {
                      let hourValue = value.slice(11, 16);

                      let valueAll = value.split("/")[2].slice(0, 4);

                      let valueYear = value
                        .split(" ")[0]
                        .slice(3, value.length);

                      let valueMonth = value.slice(0, 5);

                      if (chartContent.type == "all") {
                        if (arr != valueAll) {
                          arr = valueAll;
                          if (arr.includes("2018")) {
                            return null;
                          }
                          return arr;
                        }
                      } else if (
                        chartContent.type == "year" ||
                        chartContent.type == "ytd"
                      ) {
                        if (arr != valueYear) {
                          arr = valueYear;

                          return moment(arr, "MM/YYYY").format("MM/YY");
                        }
                      } else if (
                        chartContent.type == "month" ||
                        chartContent.type == "week"
                      ) {
                        if (arr != valueMonth) {
                          arr = valueMonth;

                          return moment(arr, "DD/MM/YYYY").format("DD/MM/YY");
                        }
                      } else if (chartContent.type == "day") {
                        if (arr != hourValue) {
                          arr = hourValue;

                          return arr;
                        }
                      } else {
                        if (arr != valueYear) {
                          arr = valueYear;

                          return moment(arr, "MM/YYYY").format("MM/YY");
                        }
                      }
                    }
                  },
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  min: this.min,
                  stepSize: this.stepSize,
                  maxTicksLimit: 5,

                  callback: function (value) {
                    let w = window,
                      x = w.innerWidth;

                    // if (x > 1200) {
                    //   return value + " (USDT)";
                    // } else {
                    //   return value;
                    // }
                    return value;
                  },
                },
              },
            ],
          },
        },
      };

      this.createChart("mainChartBlu" + this.chartId, chartData);
      this.chart = true;
    },

    createChart(chartId, chartData) {
      setTimeout(() => {
        const ctx = document.getElementById(chartId);
        const nasChart = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
      }, 100);
    },

    splitChartData(chartData) {
      this.chartDataOnChart.prices = [];
      this.chartDataOnChart.labels = [];

      for (let i = 0; i < chartData.length; i++) {
        this.chartDataOnChart.prices.push(chartData[i].close.toFixed(2));
        this.chartDataOnChart.labels.push(
          this.sharedActions.formatDateTime(chartData[i].at)
        );
      }

      let date = new Date();

      if (this.bluValue) {
        this.chartDataOnChart.prices.push(this.bluValue.value.toFixed(2));
      } else {
        console.log("error blu value");
      }

      date.setHours(date.getHours());
      this.chartDataOnChart.labels.push(
        this.sharedActions.formatDateTime(date)
      );

      this.chartDataOnChart.labels.push("");

      this.setChartData();
    },

    checkParams() {
      if (this.chartData.type == "all") {
        this.circle = 0;
      } else {
        this.circle = 2;
      }

      if (this.chartData.min != "") {
        if (this.chartData.min < 0) {
          this.min = 0;
        } else {
          this.min = this.chartData.min;
        }
      } else {
        this.min = 40;
      }

      if (this.chartData.step != "") {
        this.stepSize = this.chartData.step;
      } else {
        this.stepSize = 5;
      }
    },
  },
  computed: {},
  watch: {
    chartData: function () {
      if (this.chartData) {
        this.chart = false;
        this.checkParams();
        this.$emit("chartLoading");
        this.splitChartData(this.chartData.data);
      }
    },
  },
};
</script>
<style>
canvas {
  max-width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/public/charts_component/ChartLineCustom.vue